// extracted by mini-css-extract-plugin
export var container = "_am-1";
export var cornerButtonContainer = "_am-5";
export var disabled = "_am-2";
export var fileContainer = "_am-4";
export var hiddenInput = "_am-3";
export var widthContainer = "_am-0";